import { Body, colors, ConfirmationSvg, ErrorSvg, Icon, Spacer } from '@spritz-finance/ui'
import styled from 'styled-components'
import { FullWidthRow, Row } from '../../../../components/Layout/Row'
import { cssVar } from '../../../../theme/utils'
import { ActionLogItem } from './useFundDirectPayment'

export const TransactionLogContainer = styled.div<{ $error?: boolean }>`
    padding: 16px;
    border-radius: 10px;
    background: var(
        --surface-3,
        ${({ $error }) => ($error ? colors.coral[50] : colors.seaSpray[50])}
    );
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
`

export const TransactionLogs = ({ log }: { log: ActionLogItem | null }) => {
    if (!log) {
        return null
    }
    return (
        <FullWidthRow>
            <TransactionLogContainer $error={log.isError}>
                <Row>
                    {log.isError && (
                        <Icon
                            style={{ flexShrink: 0 }}
                            icon={ErrorSvg}
                            tint={cssVar('--text-error', colors.coral[75])}
                            size={24}
                        />
                    )}
                    {log.isSuccess && (
                        <Icon
                            style={{ flexShrink: 0 }}
                            icon={ConfirmationSvg}
                            tint={cssVar('--text-success', colors.aqua)}
                            size={24}
                        />
                    )}
                    <Spacer width={4} />
                    <Body.Med
                        size={14}
                        color={log.isError ? cssVar('--text-error', colors.coral[75]) : undefined}
                    >
                        {log.text}
                    </Body.Med>
                </Row>
            </TransactionLogContainer>
        </FullWidthRow>
    )
}
